import {
  trackFirestorePermissionDenied,
  trackSyncConflict,
} from "../service/analyticsService";

export function reportFirestorePermissionDenied(context = "unknown") {
  trackFirestorePermissionDenied({
    error_kind: "firestore_permission_denied",
    reason: String(context).slice(0, 40),
  });
}

export function reportSyncConflict(context = "unknown") {
  trackSyncConflict({
    error_kind: "sync_conflict",
    reason: String(context).slice(0, 40),
  });
}
